module.exports = __webpack_public_path__ + "static/media/bg_movel_secao3e4_atravessando_base_direita.3fc4a215.png";